// 2024/01/09 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start
import piexif from 'libs/piexif';
export const creatPhoto = (file: any, width: number, height: number): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (e) => {
      const exifInfo = piexif.load(e.target?.result as string);
      const image = new Image();
      image.src = e.target?.result as string;
      image.onload = () => {
        const flag: number = Number((width / height).toFixed(5));
        const newFlag: number = Number((image.width / image.height).toFixed(5));
        let newWidth: number = 0;
        let newHeight: number = 0;
        if (newFlag >= flag) {
          newWidth = width;
          newHeight = Math.floor(Number((width / newFlag).toFixed(5)));
        } else {
          newHeight = height;
          newWidth = Math.floor(Number((height * newFlag).toFixed(5)));
        }
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Canvas 2D context is not available.');
          return;
        }
        canvas.width = width;
        canvas.height = height;
        ctx.fillStyle = 'black';

        if (newWidth < width) {
          const diff = width - newWidth;
          ctx.fillRect(newWidth, 0, diff, height);
        }

        if (newHeight < height) {
          const diff = height - newHeight;
          ctx.fillRect(0, newHeight, width, diff);
        }
        ctx.drawImage(image, 0, 0, newWidth, newHeight);
        const url = canvas.toDataURL(file.type);
        const info = piexif.dump({ ...exifInfo });
        const newData = piexif.insert(info, url);
        resolve(newData);
      };
    };
  });
};
// 2024/01/09 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 end
